import { toast } from "react-toastify";
import { del, get, patch, post, put } from "../services/api";
import {
  CART_FETCH_SUCCESS,
  CART_FETCH_UPDATE_FAIL,
  CART_LOADING_CHANGE,
  ITEM_DELETE_FAIL,
  ITEM_DELETE_SUCCESS,
  ORDER_PLACED_SUCCESSFULLY,
  ORDER_PLACEMENT_FAIL,
  PRODUCT_ADDED_CART,
  PRODUCT_CART_ADD_FAILED,
} from "./types";
import axios from "axios";

export const fetchLinkedBundles = async (usid, type, isIndividualProduct) => {
  try {
    const res = await get(`/bundles/search/${usid}?type=${type}&isIndividualProduct=${isIndividualProduct}`);
    return res.data;
  } catch (error) {
    // toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchAllBundles = async (academicYear, studentType, productType) => {
  try {
    const params = new URLSearchParams();

    if (academicYear) params.append('academicYear', academicYear);
    if (studentType) params.append('studentType', studentType);
    if (productType) params.append('productType', productType);

    const url = `/bundles?${params.toString()}`;


    const res = await get(url);
    return res.data;
  } catch (error) {
    // toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const copyBundles = async ({ fromYear, toYear }) => {
  try {
    const res = await post("/bundles/copy-year", { fromYear, toYear });
    toast.success("Bundles copied successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    throw error;
  }
};

export const fetchAllProducts = async () => {
  try {
    const res = await get("/products");
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const addToCart =
  ({ bundleId, quantity, parentId, studentId, cartItemProducts }) =>
    async (dispatch) => {
      try {
        const res = await post("/cart/bundles", {
          bundleId,
          quantity,
          parentId,
          studentId,
          cartItemProducts
        });
        dispatch({
          type: PRODUCT_ADDED_CART,
          payload: res.data,
        });
        return Promise.resolve(res.data);
      } catch (error) {
        dispatch({
          type: PRODUCT_CART_ADD_FAILED,
          payload: error,
        });
        return Promise.reject(error);
      }
    };

export const getCartDetail = (parentId) => async (dispatch) => {
  try {
    const res = await get(`/cart/${parentId}`);
    dispatch({
      type: CART_FETCH_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: CART_FETCH_UPDATE_FAIL,
      payload: error,
    });
  }
};

export const deleteCartItem =
  ({ parentId, bundleId }) =>
    async (dispatch) => {
      try {
        const res = await del(`/cart/${parentId}/bundles/${bundleId}`);
        dispatch({
          type: ITEM_DELETE_SUCCESS,
          payload: res.data,
        });
        return Promise.resolve(res.data);
      } catch (error) {
        dispatch({
          type: ITEM_DELETE_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      }
    };

export const loadingCartChange = (value) => (dispatch) => {
  dispatch({ type: CART_LOADING_CHANGE, payload: value });
};

export const orderPlaced =
  ({ parentId, paymentMethod, shippingMethod, isAddressEdited, deliveryAddress, deliveryContact, city, state, pincode}) =>
    async (dispatch) => {
      try {
        const res = await post("/orders/cart", {
          parentId,
          shippingMethod,
          paymentMethod,
          isAddressEdited,
          deliveryAddress,
          deliveryContact,
          city,
          state,
          pincode
        });

        // If API returns error inside the response (but HTTP 200 OK)
        if (res.data?.error) {
          throw new Error(res.data.error.message || "Unknown error");
        }

        if (res.data?.success === false) {
          throw new Error(res.data?.message || "Unknown error");
        }

        dispatch({
          type: CART_LOADING_CHANGE,
          payload: false,
        });

        return Promise.resolve(res.data);
      } catch (error) {
        dispatch({
          type: ORDER_PLACEMENT_FAIL,
          payload: error.message || "Something went wrong",
        });
        return Promise.reject(error);
      }
    };

export const paymentConfig = async (orderId) => {
  try {
    const res = await get(`/payment/config/${orderId}`);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const kotakPaymentConfig = async (orderId) => {
  try {
    const res = await get(`/payment/order-config/${orderId}`);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const eazypayICICIPaymentConfig = async (orderId) => {
  try {
    const res = await get(`/payment/order-config-icici/${orderId}`);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const fetchDeliveryCharges = async (cartId) => {
  try {
    const res = await get(`/orders/calculate-delivery/${cartId}`);
    return res.data;
  } catch (error) {
    return error;
  }
};

export const paymentSuccess =
  ({ order_id, bank_reference_id, transaction_timestamp, application_code, cartItems, payment_group }) =>
    async (dispatch) => {
      try {
        const res = await post("/payment/success", {
          order_code: order_id,
          bank_reference_id,
          transaction_timestamp,
          application_code,
          cartItems,
          payment_group
        });
        dispatch({
          type: ORDER_PLACED_SUCCESSFULLY,
          payload: res,
        });
        return Promise.resolve(res.data);
      } catch (error) {
        dispatch({
          type: ORDER_PLACEMENT_FAIL,
          payload: error.message || "Something went wrong",
        });
        return Promise.reject(error);
      }
    };

export const paymentError = async ({
  order_id,
  bank_reference_id,
  transaction_timestamp,
  application_code,
  cartItems,
  error,
}) => {
  try {
    const res = await post("/payment/error", {
      error,
      application_code,
      bank_reference_id,
      order_code: order_id,
      transaction_timestamp,
      cartItems,
    });
    return res.data;
  } catch (error) {
    return error;
  }
};

export const paymentClosed = async ({ order_code, event, cartItems }) => {
  try {
    const res = await post("/payment/closed", { order_code, event, cartItems });
    return res.data;
  } catch (error) {
    return error;
  }
};

export const fetchOrderStats = async (
  searchTerm,
  startDate,
  endDate,
  currentYear
) => {
  try {
    let url = `/orders/stats/list?all=false`
    if (searchTerm) {
      url += `&search=${searchTerm}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (currentYear) {
      url += `&academic_year=${currentYear}`;
    }

    const res = await get(url);
    return res.data;
  } catch (error) {
    console.error("Error fetching order stats:", error);
    return null;
  }
};

export const fetchAllOrders = async (
  page,
  limit,
  searchTerm,
  startDate,
  endDate,
  statusFilter,
  paymentstatusFilter,
  settlementStatus,
  isVendor,
  sortKey,
  sortOrder,
  currentYear,
  all = "false",
  exportType='non-shoes',
  type = "",
  itemCategory = "",
  dateFilterBy = ""
) => {
  try {
    let url = `/orders?page=${page}&limit=${limit}&all=${all}&exportType=${exportType}`;
    if (searchTerm) {
      url += `&search=${searchTerm}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (statusFilter) {
      url += `&status=${statusFilter}`;
    }
    if (paymentstatusFilter) {
      url += `&transactionStatus=${paymentstatusFilter}`;
    }
    if (settlementStatus) {
      url += `&settlementStatus=${settlementStatus}`;
    }
    if (isVendor) {
      url += `&isVendor=${isVendor}`;
    }
    if (currentYear) {
      url += `&academic_year=${currentYear}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    if (itemCategory) {
      url += `&itemCategory=${itemCategory}`;
    }
    if (dateFilterBy) {
      url += `&dateFilterBy=${dateFilterBy}`;
    }

    if (sortKey) {
      url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return [];
  }
};

export const exportOrdersToCSVApi = async (
  searchTerm,
  startDate,
  endDate,
  statusFilter,
  paymentstatusFilter,
  settlementStatus,
  isVendor,
  sortKey,
  sortOrder,
  currentYear,
  exportType = 'non-shoes',
  type = ""
) => {
  try {
    let url = `/orders/export/csv?all=all&exportType=${exportType}`;
    if (searchTerm) {
      url += `&search=${searchTerm}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (statusFilter) {
      url += `&status=${statusFilter}`;
    }
    if (paymentstatusFilter) {
      url += `&transactionStatus=${paymentstatusFilter}`;
    }
    if (settlementStatus) {
      url += `&settlementStatus=${settlementStatus}`;
    }
    if (isVendor) {
      url += `&isVendor=${isVendor}`;
    }
    if (currentYear) {
      url += `&academic_year=${currentYear}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    if (sortKey) {
      url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
    }

    const res = await get(url, {
      responseType: 'blob'
    });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    throw error;
  }
};

export const exportOrdersToExcelApi = async (
  searchTerm,
  startDate,
  endDate,
  statusFilter,
  paymentstatusFilter,
  settlementStatus,
  isVendor,
  sortKey,
  sortOrder,
  currentYear,
  type = ""
) => {
  try {
    let url = `/orders/export/excel?all=all`;
    if (searchTerm) {
      url += `&search=${searchTerm}`;
    }
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (statusFilter) {
      url += `&status=${statusFilter}`;
    }
    if (paymentstatusFilter) {
      url += `&transactionStatus=${paymentstatusFilter}`;
    }
    if (settlementStatus) {
      url += `&settlementStatus=${settlementStatus}`;
    }
    if (isVendor) {
      url += `&isVendor=${isVendor}`;
    }
    if (currentYear) {
      url += `&academic_year=${currentYear}`;
    }
    if (type) {
      url += `&type=${type}`;
    }
    if (sortKey) {
      url += `&sortKey=${sortKey}&sortOrder=${sortOrder}`;
    }

    const res = await get(url, {
      responseType: 'blob'
    });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    throw error;
  }
};

export const fetchSelectedOrders = async (orderIds) => {
  try {
    const res = await post("/orders/selected", { orderIds });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchBulkPreview = async (orderIds) => {
  try {
    const res = await post("/orders/bulk-preview", { orderIds });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const triggerTrackingCron = async () => {
  try {
    const res = await post("/orders/trigger-tracking-cron",{});
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const gethandleTransactionsStatusCHeck = async () => {
  try {
    const res = await post("/payment/icici/check-pending-transactions",{});
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const generateOrderSlipsPdf = async (params) => {
  try {
    const res = await post(
      '/orders/print-slips',
      params,
      { responseType: 'blob' }
    );
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const printAllOrderSlipsApi = async (params) => {
  try {
    const res = await post(
      '/orders/print-all-slips',
      params,
      { responseType: 'blob' }
    );
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};


export const fetchOrdersParent = async (id) => {
  try {
    const res = await get(`/orders/parent/${id}`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateOrderStatus = async (id, data) => {
  try {
    const res = await patch(`/orders/${id}/status`, data);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateTransactionStatus = async (id, status, settlement_status, application_code) => {
  try {
    const res = await patch(`/orders/${id}/transaction-status`, { status, settlement_status, application_code });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const bulkUpdateTransactionStatus = async (bulkUpdateData) => {
  try {
    const res = await post('/orders/bulk-transaction-status', bulkUpdateData);
    return res.data;
  } catch (error) {
    // Let the component handle the error
    throw error;
  }
};

export const bulkUpdateDeliveryStatus = async (bulkUpdateData) => {
  try {
    const res = await post('/orders/bulk-delivery-status', bulkUpdateData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const findParentByPhone = async (phoneNumber) => {
  try {
    const res = await post("/parents/find-by-phone", { phoneNumber: phoneNumber });
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    toast.error(error.message, { position: "top-right" });
    return null;
  }
};

export const createProduct = async (productData) => {
  try {
    const res = await post("/products", productData);
    toast.success("Product created successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const bulkUpdateProducts = async (productData) => {
  try {
    const res = await post(`/products/bulk-update`, productData);
    toast.success("Product updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateProduct = async (id, productData) => {
  try {
    const res = await put(`/products/${id}`, productData);
    toast.success("Product updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const deleteProduct = async (id) => {
  try {
    const res = await del(`/products/${id}`);
    toast.success("Product deleted successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchBundleById = async (id, studentId) => {
  try {
    const res = await get(`/bundles/single/${id}/${studentId}`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const createBundle = async (bundleData) => {
  try {
    const res = await post("/bundles", bundleData);
    toast.success("Bundle created successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateBundle = async (id, bundleData) => {
  try {
    const res = await put(`/bundles/${id}`, bundleData);
    toast.success("Bundle updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const deleteBundle = async (id) => {
  try {
    const res = await del(`/bundles/${id}`);
    toast.success("Bundle deleted successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const syncBundle = async (id) => {
  try {
    const res = await post(`/bundles/sync/${id}`, { id });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    throw error;
  }
};

export const previewSyncBundle = async (id) => {
  try {
    const res = await get(`/bundles/sync/${id}/preview`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    throw error;
  }
};
export const updateProductSize = async (sizeData, showToast = true) => {
  try {
    const res = await post(`/sizes`, sizeData);
    if (showToast) {
      toast.success("Size updated successfully!", { position: "top-right" });
    }
    return res.data;
  } catch (error) {
    if (showToast) {
      toast.error(error.message, { position: "top-right" });
    }
    return null;
  }
};

export const getSizeLogs = async (studentId, productId) => {
  try {
    let url = "/sizes/logs";
    const params = [];
    if (studentId) params.push(`studentId=${studentId}`);
    if (productId) params.push(`productId=${productId}`);
    if (params.length > 0) url += "?" + params.join("&");

    const res = await get(url);
    return res.data;
  } catch (error) {
    console.error("Error fetching size logs:", error);
    return [];
  }
};
export const getProductsByIds = async (productIds) => {
  try {
    const res = await post("/products/by-ids", { productIds });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return {};
  }
};

export const getSizesInBulk = async (studentProductIds) => {
  try {
    const res = await post("/sizes/bulk", studentProductIds);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return {};
  }
};

export const getPaymentByOrderId = async (orderId) => {
  try {
    const res = await get(`/payment/${orderId}`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return null;
  }
};

export const verifyGqPaymentStatus = async (applicationCode) => {
  try {
    const apiKey = "cf24af42-2508-4633-b2a5-febd10795aa7";
    const authToken = "Basic R1EtMjEyNDNjNzUtYmU1Mi00ZDAyLWFiNTItZGJmMDEzNmY2ZDgyOjRlOTI4MzVjLTVkMzQtNGYzOC05MTExLWVhNjhhZGNhNTcwYQ==";

    const headers = {
      "GQ-API-Key": apiKey,
      "Authorization": authToken,
      "Content-Type": "application/json"
    };

    // Using axios directly for custom headers
    const response = await axios.get(
      `https://erp-api.grayquest.com/v1/payments/fetch?application_code=${applicationCode}`,
      { headers }
    );

    if (response.data && response.data.success) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Payment verification error:", error);
  }
};

export const fetchAcademicYears = async () => {
  try {
    const res = await get("/academic-years");
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchOrderStatusList = async () => {
  try {
    const res = await get("/orders/statuses/list");
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateOrderDeliveryStatus = async (orderId, products) => {
  try {
    const res = await patch(`/orders/item-product/${orderId}/product-delivery-status`, { products });
    toast.success("Product delivery status updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const updateOrderAddress = async (orderId, addressData) => {
  try {
    const res = await patch(`/orders/${orderId}/address`, addressData);
    toast.success(res.data?.message || "Order address updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || "Failed to update order address", { position: "top-right" });
    return error;
  }
};

export const updateOrderItemProductSize = async (orderItemProductId, size) => {
  try {
    const res = await patch(`/orders/item-product/size`, { orderItemProductId, size });
    toast.success("Size updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchOrderDeliveryStatus = async (orderId) => {
  try {
    const res = await get(`/orders/delivery-status/${orderId}`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const checkIciciStatus = async (orderId) => {
  try {
    const res = await get(`/payment/icici/status/${orderId}`);
    return res.data;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const fetchOrderById = async (orderId) => {
  try {
    const res = await get(`/orders/${orderId}`);
    return res.data?.orders;
  } catch (error) {
    toast.error(error.message, { position: "top-right" });
    return error;
  }
};

export const generateDtdcOrder = async (orderId, customerCode, showToast = true) => {
  try {
    const payload = { orderId: orderId };
    if (customerCode) payload.customerCode = customerCode;
    const res = await post(`/orders/generate/${orderId}/generate-dtdc`, payload);

    if (showToast) {
      if (res.data?.status || res.data?.success) {
        toast.success("DTDC Order generated successfully!", { position: "top-right" });
      } else {
        toast.error(res.data?.message || "Failed to generate DTDC order", { position: "top-right" });
      }
    }
    return res.data;
  } catch (error) {
    if (showToast) {
      toast.error(error.message || "Failed to generate DTDC order", { position: "top-right" });
    }
    throw error;
  }
};

export const fetchDtdcConfigs = async () => {
  try {
    const res = await get(`/dtdc-configs`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch DTDC configs:", error);
    return [];
  }
};

export const fetchActiveDtdcConfigs = async () => {
  try {
    const res = await get(`/dtdc-configs/active`);
    return res.data;
  } catch (error) {
    console.error("Failed to fetch active DTDC configs:", error);
    return [];
  }
};

export const createDtdcConfig = async (data) => {
  try {
    const res = await post(`/dtdc-configs`, data);
    toast.success("DTDC Configuration created successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message || "Failed to create DTDC config", { position: "top-right" });
    throw error;
  }
};

export const updateDtdcConfig = async (id, data) => {
  try {
    const res = await put(`/dtdc-configs/${id}`, data);
    toast.success("DTDC Configuration updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message || "Failed to update DTDC config", { position: "top-right" });
    throw error;
  }
};

export const deleteDtdcConfig = async (id) => {
  try {
    const res = await del(`/dtdc-configs/${id}`);
    toast.success("DTDC Configuration deleted successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message || "Failed to delete DTDC config", { position: "top-right" });
    throw error;
  }
};

export const setDefaultDtdcConfig = async (id) => {
  try {
    const res = await patch(`/dtdc-configs/${id}/set-default`, {});
    toast.success("Default DTDC customer code updated!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message || "Failed to set default DTDC config", { position: "top-right" });
    throw error;
  }
};

export const cancelDtdcOrder = async (orderId) => {
  try {
    const res = await post(`/orders/${orderId}/cancel-dtdc`,{orderId:orderId});
    toast.success("DTDC Order cancelled successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to cancel DTDC order", { position: "top-right" });
    throw error;
  }
};

export const fetchDtdcLabel = async (orderId, labelCode) => {
  try {
    const res = await get(`/orders/${orderId}/dtdc-label?label_code=${labelCode}`, { responseType: 'blob' });
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch DTDC label", { position: "top-right" });
    throw error;
  }
};

export const fetchDtdcTracking = async (orderId) => {
  try {
    const res = await get(`/orders/${orderId}/tracking`);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch tracking details", { position: "top-right" });
    throw error;
  }
};

export const copyOrder = async (id, suffix, amount) => {
  try {
    const res = await post(`/orders/${id}/copy`, { suffix, amount });
    toast.success("Order duplicated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to duplicate order", { position: "top-right" });
    throw error;
  }
};

export const fetchSalesReport = async (startDate, endDate, academicYear) => {
  try {
    let url = `/reports/sales?startDate=${startDate}&endDate=${endDate}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch sales report", { position: "top-right" });
    return [];
  }
};

export const fetchProductWiseReport = async (startDate, endDate, academicYear) => {
  try {
    let url = `/reports/product-wise?startDate=${startDate}&endDate=${endDate}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch product-wise report", { position: "top-right" });
    return [];
  }
};

export const fetchProductSizeWiseReport = async (startDate, endDate, academicYear) => {
  try {
    let url = `/reports/product-size-wise?startDate=${startDate}&endDate=${endDate}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch product-size-wise report", { position: "top-right" });
    return [];
  }
};

export const fetchClassWiseReport = async (startDate, endDate, academicYear, className) => {
  try {
    let url = `/reports/class-wise?startDate=${startDate}&endDate=${endDate}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    if (className) {
      const classParam = Array.isArray(className) ? className.join(',') : className;
      url += `&className=${classParam}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch class-wise report", { position: "top-right" });
    return [];
  }
};

export const fetchUserCartApi = async (parentId) => {
  try {
    const res = await get(`/cart/${parentId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserCartBundleApi = async ({ bundleId, quantity, parentId, studentId, cartItemProducts, isAdmin = true }) => {
  try {
    const res = await post("/cart/bundles", {
      bundleId,
      quantity,
      parentId,
      studentId,
      cartItemProducts,
      isAdmin,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserCartBundleApi = async ({ parentId, bundleId }) => {
  try {
    const res = await del(`/cart/${parentId}/bundles/${bundleId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchStudentBundlesApi = async (usid, isIndividualProduct = false) => {
  try {
    const res = await get(`/bundles/search/${usid}?isIndividualProduct=${isIndividualProduct}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAdminCartListApi = async (page = 1, limit = 10, search = "", onlyWithItems = true) => {
  try {
    let url = `/cart/admin/list?page=${page}&limit=${limit}&onlyWithItems=${onlyWithItems}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    const res = await get(url);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const clearAdminUserCartApi = async (parentId) => {
  try {
    const res = await del(`/cart/admin/clear/${parentId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const fetchProductSizeWeights = async (search = "", category = "") => {
  try {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (category) params.append("category", category);
    const query = params.toString() ? `?${params.toString()}` : "";
    const res = await get(`/products/size-weights${query}`);
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to fetch size weights", { position: "top-right" });
    return [];
  }
};

export const updateProductSizeWeight = async (sizeWeightData) => {
  try {
    const res = await post("/products/size-weights", sizeWeightData);
    toast.success("Size weight updated successfully!", { position: "top-right" });
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to update size weight", { position: "top-right" });
    throw error;
  }
};

export const bulkUpdateProductSizeWeights = async (items) => {
  try {
    const res = await post("/products/size-weights/bulk", items);
    if (res.data?.zeroWeightCount > 0) {
      console.warn("Records updated with weight 0:", res.data.zeroWeightRecords);
    }
    if (res.data?.failedCount > 0 && res.data?.successCount > 0) {
      toast.warn(res.data.message || `Updated ${res.data.successCount} items with ${res.data.failedCount} errors`, { position: "top-right", autoClose: 6000 });
    } else if (res.data?.success) {
      toast.success(res.data.message || "Bulk size weights updated successfully!", { position: "top-right" });
    } else {
      toast.error(res.data?.message || "Some updates could not be applied", { position: "top-right", autoClose: 6000 });
    }
    return res.data;
  } catch (error) {
    toast.error(error.message || "Failed to bulk update size weights", { position: "top-right" });
    throw error;
  }
};

export const fetchInvoicePdfBlob = async (orderId) => {
  try {
    const res = await get(`/orders/${orderId}/invoice-pdf`, { responseType: 'blob' });
    return new Blob([res.data], { type: 'application/pdf' });
  } catch (error) {
    toast.error('Failed to fetch invoice PDF from server', { position: 'top-right' });
    throw error;
  }
};

export const fetchBulkInvoicePdfBlob = async (orderIds) => {
  try {
    const res = await post(`/orders/bulk-invoice-pdf`, { orderIds }, { responseType: 'blob' });
    return new Blob([res.data], { type: 'application/pdf' });
  } catch (error) {
    toast.error('Failed to fetch bulk invoices from server', { position: 'top-right' });
    throw error;
  }
};

export const downloadInvoicePdf = async (orderId) => {
  try {
    const blob = await fetchInvoicePdfBlob(orderId);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `Invoice_${orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    throw error;
  }
};

export const downloadBulkInvoicePdf = async (orderIds) => {
  try {
    const blob = await fetchBulkInvoicePdfBlob(orderIds);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `Tax_Invoices_Bulk_${Date.now()}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    throw error;
  }
};



